import { selectActiveBranchId } from "../containers/Branches/redux/branches.slice.ts"
import type { RootState } from "../store.ts"
import { setActiveBranchHeader } from "./api"

interface StoreLike {
  getState: () => unknown
  subscribe: (listener: () => void) => () => void
}

/** Keeps the `X-Active-Branch` header on the branch the workspace switcher shows. */
export const followActiveBranch = (store: StoreLike) => {
  let last: string | null | undefined
  const sync = () => {
    const branchId = selectActiveBranchId(store.getState() as RootState)
    if (branchId === last) return
    last = branchId
    setActiveBranchHeader(branchId)
  }
  sync()
  return store.subscribe(sync)
}
